export function debugLog(...args: unknown[]) {
  if (import.meta.env.DEV || import.meta.env.VITE_DEBUG_LOGS === 'true') {
    console.log(...args);
  }
}

export function debugWarn(...args: unknown[]) {
  if (import.meta.env.DEV || import.meta.env.VITE_DEBUG_LOGS === 'true') {
    console.warn(...args);
  }
}
